import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth'
import { getFirestore, doc } from 'firebase/firestore';

// const { initializeAppCheck, ReCaptchaV3Provider } = require("firebase/app-check");

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// const appCheck = initializeAppCheck(firebaseConfig, {
//   provider: new ReCaptchaV3Provider(process.env.REACT_APP_APP_CHECK),
//   isTokenAutoRefreshEnabled: true
// });

const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)

export const db = getFirestore()

export const user = uid => doc(db, `users/${uid}`);
